import React from 'react';

interface BadgeProps {
  variant?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'error'
    | 'info';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  rounded?: boolean;
}

const Badge: React.FC<BadgeProps> = ({
  variant = 'default',
  size = 'md',
  children,
  className = '',
  style = {},
  rounded = true,
}) => {
  const getVariantStyles = (): React.CSSProperties => {
    switch (variant) {
      case 'primary':
        return {
          backgroundColor: 'var(--accent)',
          color: 'white',
          ...style,
        };
      case 'secondary':
        return {
          backgroundColor: 'var(--bg-secondary)',
          color: 'var(--text-primary)',
          border: '1px solid var(--border)',
          ...style,
        };
      case 'success':
        return {
          backgroundColor: '#10b981',
          color: 'white',
          ...style,
        };
      case 'warning':
        return {
          backgroundColor: '#f59e0b',
          color: 'white',
          ...style,
        };
      case 'error':
        return {
          backgroundColor: '#ef4444',
          color: 'white',
          ...style,
        };
      case 'info':
        return {
          backgroundColor: 'var(--accent)',
          color: 'white',
          ...style,
        };
      default:
        return {
          backgroundColor: 'var(--bg-tertiary)',
          color: 'var(--text-secondary)',
          ...style,
        };
    }
  };

  const getSizeClasses = (): string => {
    switch (size) {
      case 'sm':
        return 'px-2 py-1 text-xs';
      case 'lg':
        return 'px-4 py-2 text-base';
      default:
        return 'px-3 py-1 text-sm';
    }
  };

  const badgeClasses = [
    'inline-flex items-center font-medium',
    getSizeClasses(),
    rounded ? 'rounded-full' : 'rounded-md',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={badgeClasses} style={getVariantStyles()}>
      {children}
    </span>
  );
};

export default Badge;
